import { Navigate, Outlet } from 'react-router';
import { AppShell } from './app-shell';
import { useAuthStore } from '@/features/auth/auth.store';

export function PlatformShell() {
  const session = useAuthStore((s) => s.session);
  if (!session) return null;
  if (!session.isSuperAdmin) return <Navigate to="/app/workspace" replace />;
  return (
    <AppShell platformMode>
      <Outlet />
    </AppShell>
  );
}
